module.exports = __webpack_public_path__ + "img/hanyupu.02dcffc1.jpg";